import { render, staticRenderFns } from "./ServiceCodes.vue?vue&type=template&id=a53979c2&scoped=true&"
import script from "./ServiceCodes.vue?vue&type=script&lang=ts&"
export * from "./ServiceCodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53979c2",
  null
  
)

export default component.exports